import React, { useRef, useState } from "react";
import axios from "axios";
import { BiSolidStore } from "react-icons/bi";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { MenuContainer } from "../../styled/groupDetails";
import useOutsideClick from "../../../../../hooks/useOutsideClick";

const Member = ({ item, index, group }) => {
  const user = useSelector((state) => state?.user?.data[0]);
  const [openContext, setOpenContext] = useState(false);
  const [companies, setCompanies] = useState([]);
  const menuRef = useRef();

  useOutsideClick(menuRef, () => {
    setOpenContext(false);
    setCompanies([]);
  });

  const getHomepage = async (mberNo) => {
    const cmpnyNos = await getCmpnyMbers(mberNo);
    const domains = await getDomain(cmpnyNos);
    const cmpnyNms = await getCmpnyNms(cmpnyNos);

    const result = (domains || []).filter(Boolean).map((cmpny) => ({
      ...cmpny,
      cmpnyNm: (cmpnyNms || []).find((item) => item?.cmpnyNo === cmpny?.cmpnyNo)?.cmpnyNm || "",
    }));

    setOpenContext(true);
    setCompanies(result);
  };

  const getCmpnyNms = async (cmpnyNos) => {
    const url = "/api/cmpnyInfos";
    const body = { cmpnyNos };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        return res.data;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDomain = async (cmpnyNos) => {
    const url = "/api/domainSettingLoad";
    const requests = cmpnyNos.map((cmp) => {
      const body = {
        cmpnyNo: cmp,
        delYn: "N",
      };
      return axios.post(url, body);
    });
    const res = await Promise.all(requests);

    return res.map((req) => req.data);
  };

  const getCmpnyMbers = async (mberNo) => {
    const url = "/api/cmpnyMbers";
    const body = { mberNo };
    try {
      const res = await axios.post(url, body);
      if (res.status === 200) {
        console.log(res);
        return [
          ...new Set(
            res.data.content.filter((cmpny) => !cmpny.isDeleted).map((cmpny) => cmpny.cmpnyNo),
          ),
        ];
      }
    } catch (error) {
      console.log(error);
    }
  };

  const openPage = (domain) => {
    window.open(`https://1472.ai/shop/${domain}`, "_blank");
  };

  const clickHomepage = (member) => {
    if (member.domains.length === 1) {
      openPage(member.domains[0]);
    } else {
      getHomepage(member.mberNo);
    }
  };

  const ContextMenu = ({ companies }) => {
    return (
      <MenuContainer ref={menuRef}>
        <ul>
          {companies.map((item) => (
            <li onClick={() => openPage(item.domain)}>{item.cmpnyNm}</li>
          ))}
        </ul>
      </MenuContainer>
    );
  };

  return (
    <li key={`${item.mberNo}-${index}`}>
      {openContext && <ContextMenu companies={companies} />}
      <div className="image">
        <img
          src={item.mberImgPath ? imgHandler(item.mberImgPath) : "/img/user2.png"}
          alt="member"
        />
      </div>
      <span>
        {group.gbn && item.gbnValue ? `${item.gbnValue}${group.gbn} ` : ""}
        {item.nickNm || "닉네임 미설정"}
      </span>
      {item.domains && item.domains.length > 0 && (
        <button onClick={() => clickHomepage(item)}>
          <BiSolidStore />
        </button>
      )}
    </li>
  );
};

export default Member;
